export default "__VITE_ASSET__C8YY$YTZ__"